export const RecallStatus = {
	Completed: 2,
	Quit: 5
};
